/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CombinationDto } from './combinationDto';
import { ImplementDataDto } from './implementDataDto';
import { EmployeeDataDto } from './employeeDataDto';
import { MachineDataDto } from './machineDataDto';

export interface ActivityV2Dto {
  combination?: CombinationDto;
  dataArchived?: boolean;
  dataUpdating?: boolean;
  employeeData?: Array<EmployeeDataDto>;
  employeeDataGeometry?: Array<EmployeeDataDto>;
  id?: string;
  implementDataGeometry?: Array<ImplementDataDto>;
  implementPrimaryData?: ImplementDataDto;
  implementSecondaryData?: ImplementDataDto;
  jobIds?: Array<number>;
  machineData?: MachineDataDto;
  machineDataGeometry?: Array<MachineDataDto>;
  processId?: number;
  start?: string;
  stop?: string;
  vehicleHoursStart?: number;
  vehicleHoursStop?: number;
  vehicleMileageStart?: number;
  vehicleMileageStop?: number;
}
